import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const h = l((i, a) => /* @__PURE__ */ s.jsx(
  c,
  {
    ref: a,
    ...i,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...e,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4157)", children: [
            /* @__PURE__ */ s.jsx(
              "mask",
              {
                id: "mask0_2974_4157",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M32.63 16.94a1.419 1.419 0 1 0 .002-2.838 1.419 1.419 0 0 0-.002 2.838M39.25 38.5h-5.87V24c0-.41-.34-.75-.75-.75h-9.89V8.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v26.89L9.44 8.45a.736.736 0 0 0-.84-.43.74.74 0 0 0-.6.73v30.5c0 .41.34.75.75.75s.75-.34.75-.75V12.36l11.8 27.19c.12.28.4.45.69.45.05 0 .1 0 .15-.02.35-.07.6-.38.6-.73v-14.5h9.14V38.5h-5.87c-.41 0-.75.34-.75.75s.34.75.75.75h13.24c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4157)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4157", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
h.displayName = "AgencyNiacinamideIcon";
export {
  h as AgencyNiacinamideIcon,
  h as default
};
//# sourceMappingURL=index.js.map
